// extracted by mini-css-extract-plugin
export default {"container":"dA-z","dimension":"eA-z","dimensionLabels":"fA-z"};